module.exports = __webpack_public_path__ + "media/images/spinner-43adc30eb439a8a740e9c1d43ba101ee.svg";